import { UBER_RIDE_REQUESTED } from '../../constants/index';

const patientRequestedUberWhileBooking = (values: any) =>
  values.uberRequest === UBER_RIDE_REQUESTED;

export { patientRequestedUberWhileBooking };
